import React, { useState } from 'react';
import { http } from '../../lib/http';
import { useI18n } from '../../contexts/I18n';

export default function PasswordChanger({ tempPassword, onPasswordCleared }) {
  const { t } = useI18n();
  const [pwMsg, setPwMsg] = useState('');
  const [pwErr, setPwErr] = useState('');
  const [pw, setPw] = useState({ currentPwd: tempPassword || '', newPwd: '' });
  const [showCurrentPwd, setShowCurrentPwd] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);

  const onPw = (e) => setPw((p) => ({ ...p, [e.target.name]: e.target.value }));

  const changePw = async () => {
    setPwErr('');
    setPwMsg('');
    if (!pw.currentPwd || !pw.newPwd) {
      setPwErr(t('passwordFillBoth'));
      return;
    }
    if (pw.newPwd.length < 8) {
      setPwErr(t('passwordMinLength'));
      return;
    }
    try {
      const data = await http.post('/api/shopowner/password', pw);
      setPwMsg(data.message || t('passwordUpdatedSuccess'));
      setPw({ currentPwd: '', newPwd: '' });
      onPasswordCleared?.();
    } catch (err) {
      setPwErr(err.message || t('passwordUpdateFailed'));
    }
  };

  return (
    <div className="password-change-form" style={{ width: '100%' }}>
      {pwErr && (
        <p className="form-err" style={{ marginBottom: 8 }}>
          {pwErr}
        </p>
      )}
      {pwMsg && (
        <p className="form-ok" style={{ marginBottom: 8 }}>
          {pwMsg}
        </p>
      )}
      <label>
        {t('currentPassword')}
        <div className="password-toggle-container">
          <input
            type={showCurrentPwd ? 'text' : 'password'}
            name="currentPwd"
            value={pw.currentPwd}
            onChange={onPw}
          />
          <button
            type="button"
            className="password-toggle-btn"
            onClick={() => setShowCurrentPwd(!showCurrentPwd)}
            title={showCurrentPwd ? t('hidePassword') : t('showPassword')}
          >
            {showCurrentPwd ? (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
              </svg>
            )}
          </button>
        </div>
      </label>
      <label>
        {t('newPassword')}
        <div className="password-toggle-container">
          <input
            type={showNewPwd ? 'text' : 'password'}
            name="newPwd"
            value={pw.newPwd}
            onChange={onPw}
          />
          <button
            type="button"
            className="password-toggle-btn"
            onClick={() => setShowNewPwd(!showNewPwd)}
            title={showNewPwd ? t('hidePassword') : t('showPassword')}
          >
            {showNewPwd ? (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
              </svg>
            )}
          </button>
        </div>
      </label>
      <div style={{ marginTop: 8 }}>
        <button type="button" className="mini" onClick={changePw}>
          {t('updatePassword')}
        </button>
      </div>
    </div>
  );
}
